// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/badge/style/index.less
// module id = 1018
// module chunks = 0